<template>
  <v-container ma-0 pa-0 fluid fill-height>
    <v-layout fill-height>
      <v-flex xs12 pa-0 fill-height>
        <div v-if="screenMode" class="screenColor" :style="{ backgroundColor: colour}"></div>
        <div v-if="!screenMode" style="position:absolute;">
          <div
            class="screenPreview"
            :style="{backgroundColor: colour, width:'136px',height:'81px',display:'inline-block',position:'relative',top:'10px',left:'10px',paddingTop:'20%','text-align':'center'}"
          >Screen Colour</div>
        </div>

        <canvas v-if="!screenMode" id="colorspace" style="width:100%;height:100%;"></canvas>
        <div
          v-if="screenMode"
          class="screenText"
        >Colour the screen at www.theloophobart.com.au/colour</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      hasTouch: false,
      canvas: null,
      ctx: null,
      xPos: null,
      yPos: null,
      screenCol: null,
      mouseIsDown: false
    };
  },
  mounted() {
    //this.$store.dispatch('loadStatus');
    this.$store.dispatch("loadColour");
    console.log("MOUNTED", this.colour);
    if (!this.screenMode) {
      this.canvas = document.getElementById("colorspace");
      this.ctx = this.canvas.getContext("2d");
      this.buildColorPalette();
      this.canvas.onmousemove = this.mouseMove;
      this.canvas.onmousedown = this.mouseDown;
      document.onmouseup = this.mouseUp;
      this.canvas.ontouchmove = this.touchMove;
    }
  },
  computed: {
    screenMode() {
      return this.$route.path.indexOf("screen") > -1;
    },
    colour() {
      return this.$store.getters.getColour;
    },

    loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  },

  methods: {
    mouseDown(event) {
      this.mouseIsDown = true;
      this.mouseMove(event);
    },
    mouseUp(event) {
      this.mouseIsDown = false;
    },
    touchMove(event) {
      this.yPos =
        ((event.pageY - this.canvas.offsetTop) / this.canvas.scrollHeight) *
        this.canvas.height;
      this.xPos =
        ((event.pageX - this.canvas.offsetLeft) / this.canvas.scrollWidth) *
        this.canvas.width;
      this.getColor();
    },
    mouseMove(event) {
      if (this.mouseIsDown) {
        this.yPos =
          ((event.pageY - this.canvas.offsetTop) / this.canvas.scrollHeight) *
          this.canvas.height;
        this.xPos =
          ((event.pageX - this.canvas.offsetLeft) / this.canvas.scrollWidth) *
          this.canvas.width;
        this.getColor();
      }
    },
    getColor() {
      var imageData = this.ctx.getImageData(this.xPos, this.yPos, 1, 1);
      console.log(imageData);
      this.screenCol =
        "rgb(" +
        imageData.data[0] +
        ", " +
        imageData.data[1] +
        ", " +
        imageData.data[2] +
        ")";
      this.setColour(this.screenCol);
    },
    buildColorPalette() {
      var gradient = this.ctx.createLinearGradient(0, 0, this.canvas.width, 0);
      // Create color gradient
      gradient.addColorStop(0, "rgb(127,   127,   127)");
      gradient.addColorStop(0.04, "rgb(127,   127,   127)");
      gradient.addColorStop(0.05, "rgb(255,   0,   0)");
      gradient.addColorStop(0.2, "rgb(255,   0, 255)");
      gradient.addColorStop(0.35, "rgb(0,     0, 255)");
      gradient.addColorStop(0.5, "rgb(0,   255, 255)");
      gradient.addColorStop(0.65, "rgb(0,   255,   0)");
      gradient.addColorStop(0.8, "rgb(255, 255,   0)");
      gradient.addColorStop(1, "rgb(255,   0,   0)");
      // Apply gradient to canvas
      this.ctx.fillStyle = gradient;
      this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      // Create semi transparent gradient (white -> trans. -> black)
      gradient = this.ctx.createLinearGradient(0, 0, 0, this.canvas.height);
      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
      gradient.addColorStop(0.5, "rgba(255, 255, 255, 0)");
      gradient.addColorStop(0.5, "rgba(0,     0,   0, 0)");
      gradient.addColorStop(1, "rgba(0,     0,   0, 1)");
      // Apply gradient to canvas
      this.ctx.fillStyle = gradient;
      this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },

    setColour(col) {
      this.$store.dispatch("setColour", col);
    }
  }
};
</script>
<style>
main {
  height: 100%;
  overflow: hidden;
}
</style>
<style scoped>
.screenText {
  position: absolute;
  bottom: 50px;
  text-align: center;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-shadow: 0px 0px 10px #000;
}
.screenPreview {
  color: #fff;
  text-shadow: 0px 0px 10px #000;
  background-color: #000;
}
.screenColor {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Play/Colour.vue